import React from 'react';
import propTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserRole, signIn, signOut } from "../services/common/auth";

const AuthContext = React.createContext();

function AuthProvider({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser, setCurrentUser] = React.useState(null);

  async function signInUser(usernameOrSignInOpts = '', password = '') {
    const res = await signIn(usernameOrSignInOpts, password);

    if (!res) {
      setCurrentUser(null);
      return false;
    }

    const user = { username: res.username };
    const role = await getUserRole(res.username);

    if (role === 'crm' || role === 'admin' ) {
      setCurrentUser(user);
      const origin = location.state?.from?.pathname || '/home';
      navigate(origin);
      return true;
    }

    await signOut();
    setCurrentUser(null);
    return false;
  }

  async function signOutUser() {
    await signOut();
    setCurrentUser(null);
    navigate('/');
  }

  const value = {
    currentUser,
    signInUser,
    signOutUser,
    setCurrentUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: propTypes.node.isRequired,
};

export { AuthContext, AuthProvider };
